import styled from 'styled-components'

const TruncateWidth = styled.div`
width: ${props => props.width + 'px'}
white-space: nowrap
overflow: hidden
  text-overflow: ellipsis 
`

TruncateWidth.propTypes = {
  width: 100
}

export default TruncateWidth


// WEBPACK FOOTER //
// ./src/components/views/widgets/TruncateWidth.js